import { memo } from 'react';

import { ConfirmationModal } from '@air/component-confirmation-modal';

export type ContentCollectionApplyAllModalProps = {
  onApplyAll: () => void;
};

export const ContentCollectionApplyAllModal = memo(
  ({ onClose, onApplyAll }: AirModalProps<ContentCollectionApplyAllModalProps>) => {
    return (
      <ConfirmationModal
        ctaPrimaryText="Keep existing fields"
        ctaSecondaryText="Overwrite all"
        description="Applying details to all items will overwrite any fields you’ve entered individually. You can choose to keep your current selections or replace all values."
        id="content-collection-apply-all-modal"
        isOpen
        onConfirm={onClose}
        onDismiss={onApplyAll}
        title="Keep existing fields?"
      />
    );
  },
);

ContentCollectionApplyAllModal.displayName = 'ContentCollectionApplyAllModal';
